module.exports = __webpack_public_path__ + "static/pix-458e2830d08e4e4e4bab7e8eca85f663.png";